export interface AuthState {
  sessionToken: string | null;
}

export const initialAuthState: AuthState = {
  sessionToken: null,
};

type Action =
  | { type: 'SET_API_TOKEN'; payload: string }
  | { type: 'LOGOUT' }
  | { type: string; payload?: any };

const authReducer = (
  state: AuthState = initialAuthState,
  action: Action
): AuthState => {
  switch (action.type) {
    case 'SET_API_TOKEN':
      console.log('🪵 [REDUCER] SET_API_TOKEN received:', action.payload);
      return { ...state, sessionToken: action.payload };

    case 'LOGOUT':
      return { ...initialAuthState };

    default:
      return state;
  }
};

export default authReducer;
